import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroFeatures from "../components/HeroFeatures";
import Footer from "../components/Footer";
import { updateSEO, buildBreadcrumbSchema } from "../utils/seo";

/**
 * Standalone sub-page that hosts the "Three reasons your campus commute
 * just got better" section. Same component as on Home — adds top padding
 * so the fixed Navbar doesn't overlap the headline.
 */
const WhySaferSavvy: React.FC = () => {
  useEffect(() => {
    updateSEO({
      title: "Why SaferSavvy — 3 Reasons Your Campus Commute Just Got Better",
      description:
        "Discover why SaferSavvy is the smartest university transport automation solution. AI-powered routing, real-time tracking, and smart card boarding make your campus commute safer, faster, and smarter.",
      canonical: "/why-safersavvy",
      keywords:
        "why SaferSavvy, university transport automation, AI bus routing benefits, campus transport features, smart campus commute",
      jsonLd: buildBreadcrumbSchema([
        { name: "Home", url: "/" },
        { name: "Why SaferSavvy", url: "/why-safersavvy" },
      ]),
    });
  }, []);

  return (
    <div className="font-sans text-gray-800 dark:text-ink-100 dark:bg-ink-850 overflow-x-hidden min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 sm:pt-28">
        <HeroFeatures />
      </main>
      <Footer />
    </div>
  );
};

export default WhySaferSavvy;
